<template>
  <div class="columns is-multiline is-mobile">
    <div class="column is-full-mobile">
      <window title="vue-recaptcha <a href='https://github.com/DanSnow/vue-recaptcha'
                                      target='_blank'>(more info)" height="100%">
        <vue-recaptcha sitekey="6LfQJV8UAAAAAFAeg0aA6YjRigVeWLFCY5OVMDF6">
        </vue-recaptcha>
      </window>
    </div>
    <div class="column is-full-mobile">
      <window title="vue-invisible-recaptcha <a href='https://github.com/MicroDroid/vue-invisible-recaptcha'
                                                target='_blank'>(more info)" height="100%">
        <invisible-recaptcha sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" :validate="prepare"
          :callback="doSomething" class="btn btn-danger" type="submit" id="do-something-btn"
          :disabled="loading"
        >
          Do something!
        </invisible-recaptcha>
      </window>
    </div>
  </div>

</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import InvisibleRecaptcha from 'vue-invisible-recaptcha';

export default {
  components: {
    'invisible-recaptcha': InvisibleRecaptcha,
    'vue-recaptcha': VueRecaptcha,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    doSomething() {
      this.loading = true;
    },
    prepare() {},
  },
};
</script>
